import { render, staticRenderFns } from "./modal_galeria.vue?vue&type=template&id=39f8fb57&scoped=true"
import script from "./modal_galeria.vue?vue&type=script&lang=js"
export * from "./modal_galeria.vue?vue&type=script&lang=js"
import style1 from "./modal_galeria.vue?vue&type=style&index=1&id=39f8fb57&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f8fb57",
  null
  
)

export default component.exports